import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';

import { VerticaLinkedService } from 'app/model/linkedservice/vertica.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.vertica.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.Vertica_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.Vertica_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: VerticaLinkedService.MODEL // Linked service redefined
        }
    }
})
export class VerticaTableDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
